/**
 * !Declare custom directive
 * docs: https://vuejs.org/v2/guide/custom-directive.html
 * example: https://stackoverflow.com/a/42389266/8434053
 */
export default {
  bind: (el, binding, vnode) => {
    el.clickOutsideEvent = event => {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: el => {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
};
